import React, { FC } from 'react';

export const StopPropagation: FC = ({ children }) => {
  return <span onClick={(e) => e.stopPropagation()}>{children}</span>;
};
